export const truncateAddress = (address: string, start = 6, end = 6): string =>
  address.substring(0, start) + ' ... ' + address.slice(-end);
